import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class BillingAccountsDisplayListComponent implements IController {

  ids: any;
  isRow: any;
  rowLimit: any;
  disabledIds: any;

  onChange: Function;

  private billingAccountsRef: any;
  private displayItems: any;

  /* @ngInject */
  constructor(private $billingAccounts, private $log) {
  }

  $onInit() {
    this.billingAccountsRef = this.$billingAccounts();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.billingAccountsRef.$asyncValues(ids)
        .then((accounts) => {
          const displayItems = [];
          _.forEach(accounts, (a) => {
            displayItems.push({id: a.id, value: a.accountingName})
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.displayItems = [];
    }
  }


}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccountsDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      disabledIds: '<?',
      onChange: '&'
    },
    template: require('./billing-accounts-display-list.html').default,
    controller: BillingAccountsDisplayListComponent
  });
